<popup [header]="viewForm.title" [(visible)]="display" modal="modal" [closable]="false"
 width="450" responsive="true" (onShow)="onShow()" (onHide)="onHide($event)">
    <div class="modal_area" *ngIf="display">
        <div class="modal_area" *ngIf="viewForm">


            <div class="title_1" *ngIf="viewForm.timeout>0" >{{'為了提供您更好的服務，系統將進行停機維護，'|i18n:'common00005364':null}}

                <span class="txt_red">{{viewForm.timeout}}</span>
                {{'秒後會將您登出本系統，造成不便，敬請見諒。'|i18n:'common00004846':null}}
            </div>

            <div class="title_1" *ngIf="viewForm.timeout==0">{{'為了提供您更好的服務，系統已停機維護，造成不便，敬請見諒。'|i18n:'common00002931':null}}</div>
        </div>

        <div class="btn_box">
            <commandButton [mask]="false"  *ngIf="viewForm.timeout>0"  (onClick)="onHide($event)">{{'繼續'|i18n:'common00001424':null}}</commandButton>
            <commandButton [mask]="false" (onClick)="doConfirm($event)">{{'現在登出'|i18n:'common00001352':null}}</commandButton>
        </div>
    </div>
</popup>
